import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { MsalProvider } from "@azure/msal-react";
import { AuthHelperProvider } from "../contexts/AuthHelper";
import { SubscriptionProvider } from "../contexts/Subscription";
import { auth } from "../model/auth";
import { Content } from "./Content";
import { DocumentTitle } from "./DocumentTitle";

export const App: React.FC = () => {
  return (
    <SubscriptionProvider>
      <MsalProvider instance={auth}>
        <AuthHelperProvider>
          <FluentProvider theme={webLightTheme}>
            <DocumentTitle />
            <Content />
          </FluentProvider>
        </AuthHelperProvider>
      </MsalProvider>
    </SubscriptionProvider>
  );
};
